module.exports = __webpack_public_path__ + "static/dune-messiah-c24c3fefd04300e5d46e240edb319e62.jpg";